import { useSyncExternalStore } from "react";

/**
 * Temporary try-on for shop cosmetics (avatars, username styles, board themes).
 * Does not persist — cleared on exit preview or leaving the shop.
 */
const EMPTY = { item: null };

let snapshot = EMPTY;
const listeners = new Set();

function emit() {
  for (const fn of listeners) {
    fn();
  }
}

export function getCosmeticPreview() {
  return snapshot;
}

export function subscribeCosmeticPreview(listener) {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

export function useCosmeticPreview() {
  return useSyncExternalStore(subscribeCosmeticPreview, getCosmeticPreview, getCosmeticPreview);
}

/** @param {object|null} item Shop catalog item, or null to clear. */
export function setCosmeticPreview(item) {
  if (!item?.id || !item?.type) {
    if (snapshot.item) {
      snapshot = EMPTY;
      emit();
    }
    return;
  }
  snapshot = { item };
  emit();
}

export function clearCosmeticPreview() {
  if (!snapshot.item) return;
  snapshot = EMPTY;
  emit();
}

export function isPreviewingItem(itemId) {
  return snapshot.item?.id === itemId;
}
